import React from 'react';
import { AcornProduct } from '../generated/types-and-hooks';
import { DEFAULT_IMAGE_HASH, generateImageCdnPath, ImageSize } from './images';
import { productTitle } from './jsonld';
import _ from 'lodash';

const siteTitle = 'Mountain Valley Growers';

export type ProductTagsInput = {
  siteUrl: string;
  product: AcornProduct;
};
export const ProductTags = ({
  siteUrl,
  product,
}: ProductTagsInput): JSX.Element => {
  const title = productTitle(product);
  const url = `${siteUrl}/organic-plants/${product.Slug}`;
  const image = generateImageCdnPath(
    _.get(product, ['ImageHashes', 0], DEFAULT_IMAGE_HASH),
    ImageSize.Medium,
  );
  return (
    <>
      <meta id="name" itemProp="name" content={`${title} | ${siteTitle}`} />
      <meta
        id="description"
        itemProp="description"
        content={product.Description}
      />
      <meta id="image" itemProp="image" content={image} />

      <meta id="og-url" property="og:url" content={url} />
      <meta id="og-type" property="og:type" content="website" />
      <meta
        id="og-title"
        property="og:title"
        content={`${title} | ${siteTitle}`}
      />
      <meta
        id="og-description"
        property="og:description"
        content={product.Description}
      />
      <meta id="og-image" property="og:image" content={image} />

      <meta
        id="twitter-card"
        name="twitter:card"
        content="summary_large_image"
      />
      <meta
        id="twitter-title"
        name="twitter:title"
        content={`${title} | ${siteTitle}`}
      />
      <meta
        id="twitter-description"
        name="twitter:description"
        content={product.Description}
      />
      <meta id="twitter-image" name="twitter:image" content={image} />
    </>
  );
};
